import config from "config.json";

export const apiHost = config.host;
export const googleLoginId = config.googleLoginId;
export const greetList = config.greetList;
export const colorList = config.colorList;
